import { css } from 'styled-components'


export const media = {
   mobile: (...args) => css`
    @media (max-width: 500px) {
      ${css(...args)};
    }
  `,
   deskTop: (...args) => css`
    @media(min-width: 501px){
      ${css(...args)};
    }
  `,
}